<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->
<div class="title has-text-centered">Your organisation</div>
<div class="subtitle has-text-centered">Community Benefit Society</div>

  <div class="block">
    <div class="field">
      <label class="label">Name</label>
      <div class="control">
        <input
          class="input"
          type="text"
          placeholder="Required"
          bind:value={charity.name}
        />
      </div>
    </div>

    <div class="field">
      <label class="label">CBS Registration Number</label>
      <div class="control">
        <input
          class="input"
          type="text"
          placeholder="Required"
          bind:value={registrationNumber}
        />
      </div>
    </div>

    <div class="field">
      <label class="label">Website</label>
      <div class="control">
        <input
          class="input"
          type="text"
          placeholder="Optional"
          bind:value={charity.website}
        />
      </div>
    </div>

    <div class="field">
      <label class="label">Postcode</label>
      <div class="control">
        <input
          class="input"
          type="text"
          placeholder="Required"
          bind:value={charity.contact.postcode}
        />
      </div>
    </div>
  </div>

<div class="block">
  <button
    disabled={!isValid}
    class="button is-primary"
    class:is-loading={isLoading}
    on:click={submit}>Submit</button
  >
</div>

{#if errorMessage}
  <div class="block">
    <div class="notification is-danger is-light">
      {errorMessage}
    </div>
  </div>
{/if}

<div class="block"><a href={$url('/start/charity/type')}>&lt; Select a different type of charity</a></div>


<script lang="ts">
  import { goto, url } from "@sveltech/routify";
  import { logging } from '../../../../lib/logging';
  import { appState } from "../../../../lib/appState";

  import _ from "lodash";

  let isLoading = false;
  let errorMessage : string;

  let registrationNumber = '';

  let charity : Charity_v2 = {
    type: 'CBS',
    name: '',
    location: undefined,
    description: '',
    contact: {
      email: '',
      phone: '',
      address: [],
      social: [],
      postcode: ''
    },
    website: '',
    info: {
      name: '',
      registrationNumber: ''
    }
  };

  $: isValid =
    charity != undefined && charity.name && charity.contact.postcode;

  async function submit() {
    isLoading = true;

    (charity.info as CBS).name = charity.name;
    (charity.info as CBS).registrationNumber = registrationNumber;

    try {
      await window.firebase
        .functions()
        .httpsCallable('api-account-createcharity')({ charity } as CreateCharityParams)
        .then((result) => {
          $appState.user!.charity = result.data.id;

          isLoading = false;
          $goto('../../ready');
        });
    } catch (err :any) {
      logging.report(err.toString());
      errorMessage = err.toString();
    }

    isLoading = false;
  }

</script>
